import React from 'react';
import { Dropdown } from 'rsuite';
import { StyledDropdownItem } from './card-viewer-header-styles';
import { FaSort, FaSortAmountDown } from 'react-icons/fa';

const SORT_OPTIONS = {
  APN: {
    itemLabel: 'Highest APN',
    dataLabel: 'apn',
  },
  REVENUE: {
    itemLabel: 'Highest Revenue',
    dataLabel: 'latestRevenue',
  },
  ADR: {
    itemLabel: 'Highest Avg Daily Rate',
    dataLabel: 'adr',
  },
  OCCUPANCY: {
    itemLabel: 'Highest Occupancy Rate',
    dataLabel: 'latestOccupancy',
  },
};

const SortDropdownItem = ({ itemLabel, onSelect, active }) => (
  <StyledDropdownItem
    active={active}
    icon={active ? <FaSortAmountDown /> : null}
    onSelect={onSelect}
  >
    {itemLabel}
  </StyledDropdownItem>
);

export function SortDropdown({ sortApplied, userToggledSort }) {
  return (
    <Dropdown icon={<FaSort />} title="Sort by">
      {Object.values(SORT_OPTIONS).map((option) => (
        <SortDropdownItem
          key={option.itemLabel}
          itemLabel={option.itemLabel}
          active={sortApplied.type === option.dataLabel}
          onSelect={() => userToggledSort(option.dataLabel, 'desc')}
        />
      ))}
    </Dropdown>
  );
}
